import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export default function CreatedAtField({ value, saving, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label="Created At"
        value={value || dayjs()}
        onChange={onChange}
        disabled={saving}
        slotProps={{
          textField: { fullWidth: true, size: 'small' },
        }}
      />
    </LocalizationProvider>
  );
}